import { KatStatusindicator } from "@amzn/katal-react";
import classNames from "classnames";
import React, { type FC } from "react";
import { useTranslation } from "react-i18next";
import {
  type StatusIndicator,
  ValidationRuleSeverity,
} from "src/api/interfaces/document_validation";
import type { MismatchTableFields } from "src/api/interfaces/validation_result";
import type { DataTableCellChildComponentProps } from "src/components/DataTable/DataTableDefinition";
import styles from "src/styles.module.scss";
import { getTranslatedValue } from "src/utils";

const INFO_TYPE = "information";
const ERROR_TYPE = "error";

const VALIDATION_RULE_SEVERITY_TO_STATUS_INDICATOR_TYPE: Map<
  string,
  StatusIndicator
> = new Map([
  [
    ValidationRuleSeverity.CRITICAL.valueOf(),
    { statusType: ERROR_TYPE, style: styles.status_critical },
  ],
  [
    ValidationRuleSeverity.ERROR.valueOf(),
    { statusType: ERROR_TYPE, style: styles.status_serious },
  ],
  [
    ValidationRuleSeverity.INFO.valueOf(),
    { statusType: ERROR_TYPE, style: styles.status_information },
  ],
  [
    ValidationRuleSeverity.SEVERE.valueOf(),
    { statusType: ERROR_TYPE, style: styles.status_serious },
  ],
  [
    ValidationRuleSeverity.WARNING.valueOf(),
    { statusType: ERROR_TYPE, style: styles.status_minor },
  ],
]);

const MismatchSeverityIndicator: FC<MismatchTableDataProps> = ({
  content,
  translateValue,
}) => {
  const { t } = useTranslation();
  const validationRuleSeverityText = content.ruleSeverity.valueOf();
  const translatedValidationRuleSeverityText = translateValue
    ? getTranslatedValue(validationRuleSeverityText, t)
    : validationRuleSeverityText;

  const statusIndicatorType: StatusIndicator =
    VALIDATION_RULE_SEVERITY_TO_STATUS_INDICATOR_TYPE.get(
      validationRuleSeverityText
    ) || { statusType: INFO_TYPE };
  return (
    <KatStatusindicator
      label={translatedValidationRuleSeverityText}
      variant={statusIndicatorType.statusType}
      className={classNames(styles.capitalizedText, statusIndicatorType.style)}
    />
  );
};

export type MismatchTableDataProps =
  DataTableCellChildComponentProps<MismatchTableFields>;

export default MismatchSeverityIndicator;
